import { BaseService } from "./../../base";
export class ProfessionalService extends BaseService {
  static get entity() {
    return "professional";
  }
  static get name() {
    return "professional";
  }
  static async getByState(state) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_state/${state}`, this.name);
  }
}
